import { SearchFormBase } from "mixs/base/form_mixin";
import { get } from "apps/actions/common";
import serialize        from 'utilities/serialize';
import { deepmerge }    from 'utilities/merge';
import visit            from 'utilities/visit';
import { parse, stringify } from "query-string";
import {
  BEFORE_VALIDATION,
  AFTER_VALIDATION,
  BEFORE_SUBMIT,
  AFTER_SUBMIT
} from 'apps/events';

// this class is also used as super class in 'forms/orders/search'
export class PlannerSearch extends SearchFormBase {
  protected validKey(key){
    if(/^(id|k|s|d|t|c|u|p|h|r|m|b|odr)$/.test(key)) return true;
    if(/^page$/.test(key)) return true;
    return false;
  }
  protected setParamsByKey(inputs, key, params){
    let value = inputs[key].value
    if(value == null || value == ''){
      // continue;
    }else if(
      (key == 'order_type' || key == 'phase_id' || key == 'stage') &&
      value.split(',').length == inputs[key].items.length
    ){
    }else if(key == 'order' && value == 'j'){
    }else {
      let name = inputs[key].name
      params[name] = inputs[key].value
    }
  }
  // protected submit(){ //normal access (not ajax)
  //   let form   = this.getParamsByData();
  //   let search = this.getParamsBySearch();
  //   let queryObj = deepmerge(search, form);
  //   let query = serialize(queryObj);
  //   let uri = this.getNewURI(query);
  //   if(uri != null){
  //     visit(uri);
  //   }
  //   return false;
  // }
  // protected getParamsBySearch(){
  //   let params = parse(window.location.search);
  //   let newParams = {};
  //   for(let key in params){
  //     if(/^[k|s|t|c|u|p|h|r|m|b]$/.test(key)) continue;
  //     if(/^page$/.test(key)) continue;
  //     newParams[key] = params[key];
  //   }
  //   return newParams;
  // }
  // public onSubmit(e){
  //   e.preventDefault();
  //   this.submit();
  //   return false;
  // }
  // protected getParamsByData(){
  //   let params = {}
  //   let inputs = this.opts.inputs
  //   for(let key in inputs){
  //     let value = inputs[key].value
  //     if(value == null || value == ''){
  //       continue;
  //     // }else if(key == 'status' && value == '4'){
  //     //   // statusはデフォルトで4なのでその場合パラメータに入れない
  //     //   continue;
  //     }else if(
  //       (key == 'order_type' || key == 'phase_id' || key == 'stage') &&
  //       value.split(',').length == inputs[key].items.length
  //     ){
  //       // order_typeもしくはphase_idはデフォルトで全てなので、
  //       // 全てのチェックが入っている場合はパラメータに入れない
  //       continue;
  //     } else {
  //       let name = inputs[key].name
  //       params[name] = inputs[key].value
  //     }
  //   }
  //   return params
  // }
}

riot.mixin("forms.planner.search", PlannerSearch as riot.TagMixin);
